/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProjectDTO
 */
export interface ProjectDTO {
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    organizationId: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    organizationName: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    projectKey: string;
    /**
     * 
     * @type {string}
     * @memberof ProjectDTO
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ProjectDTO
     */
    version: number;
}

/**
 * Check if a given object implements the ProjectDTO interface.
 */
export function instanceOfProjectDTO(value: object): value is ProjectDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    if (!('projectKey' in value) || value['projectKey'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    return true;
}

export function ProjectDTOFromJSON(json: any): ProjectDTO {
    return ProjectDTOFromJSONTyped(json, false);
}

export function ProjectDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'organizationId': json['organizationId'],
        'organizationName': json['organizationName'],
        'projectKey': json['projectKey'],
        'name': json['name'],
        'version': json['version'],
    };
}

export function ProjectDTOToJSON(value?: ProjectDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'organizationName': value['organizationName'],
        'projectKey': value['projectKey'],
        'name': value['name'],
        'version': value['version'],
    };
}

